const features = [
  { icon: "ri-truck-line", title: "Frete para todo o Brasil" },
  { icon: "ri-shield-check-line", title: "Compra 100% Segura" },
  { icon: "ri-bank-card-line", title: "Parcele em até 12x no cartão" },
  { icon: "ri-customer-service-2-line", title: "Atendimento Especializado" },
  { icon: "ri-gift-line", title: "Produtos Selecionados" },
];

export default function FeaturesBar() {
  return (
    <div className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-none grid-cols-2 gap-y-6 px-4 py-7 md:grid-cols-3 md:px-6 lg:grid-cols-5">
        {features.map((feature) => (
          <div key={feature.title} className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600">
              <i className={`${feature.icon} text-xl`}></i>
            </span>
            <span className="text-sm font-medium leading-snug text-foreground-800">
              {feature.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
